import { useQuery } from '@apollo/client';
import { notEmpty } from '@crehana/utils';

import GET_SKILL_XP_RESULTS from '../graphql/GetSkillXQResults.graphql';
import type {
  GetSkillXQResults,
  GetSkillXQResultsVariables,
} from '../graphql/types/GetSkillXQResults';

const useSkillXPResults = (skillB2BUserId: number | null) => {
  const { data, loading, error, refetch } = useQuery<
    GetSkillXQResults,
    GetSkillXQResultsVariables
  >(GET_SKILL_XP_RESULTS, {
    variables: { skillB2BUserId },
    skip: !skillB2BUserId,
  });

  const strengths =
    data?.skillsB2BUserResult?.resultSkill?.resultGroupTags?.strengths!.map(
      el => {
        return {
          originalId: el?.tag?.originalId,
          name: el?.tag?.name,
          percent: el?.percent,
          description: el?.tag?.description,
        };
      },
    ) || [];
  const weaknesses =
    data?.skillsB2BUserResult?.resultSkill?.resultGroupTags?.weaknesses!.map(
      el => {
        return {
          originalId: el?.tag?.originalId,
          name: el?.tag?.name,
          percent: el?.percent,
          description: el?.tag?.description,
        };
      },
    ) || [];

  const yAxisScore = data?.skillsB2BUserResult?.resultSkill?.resultSkill || 0;
  const xAxisScore = Math.cbrt((yAxisScore - 39) / 0.0004) + 46;
  const yAxisPreviousScore =
    data?.skillsB2BUserResult?.resultSkill?.resultPrevious || null || 0;
  const xAxisPreviousScore = yAxisPreviousScore
    ? Math.cbrt((yAxisPreviousScore - 39) / 0.0004) + 46
    : null;

  const level = data?.skillsB2BUserResult?.resultSkill?.level || '';
  const resultLevelAll =
    data?.skillsB2BUserResult?.resultSkill?.resultLevelAll || [];
  const lowLevelStudents =
    resultLevelAll.find(el => el?.level === 1)?.quantity || 0;
  const midLevelStudents =
    resultLevelAll.find(el => el?.level === 2)?.quantity || 0;
  const highLevelStudents =
    resultLevelAll.find(el => el?.level === 3)?.quantity || 0;
  const courses =
    data?.skillsB2BUserResult?.resultSkill?.recommendedCourses?.filter(
      notEmpty,
    ) || [];
  const canSelectTeam = data?.skillsB2BUserResult?.resultSkill?.canSelectTeam;
  const scoreMySkill = data?.skillsB2BUserResult?.resultSkill?.scoreMySkill;
  const scoreAllSkill = data?.skillsB2BUserResult?.resultSkill?.scoreAllSkill;
  const averageScore = data?.skillsB2BUserResult?.resultSkill?.averageScore;
  const averageScoreAllTrack =
    data?.skillsB2BUserResult?.resultSkill?.averageScoreAllTrack;
  const certificateDownloadUrl =
    data?.skillsB2BUserResult?.resultSkill?.certificate?.attachmentUrl;
  const certificateImage =
    data?.skillsB2BUserResult?.resultSkill?.certificate?.imageUrl;

  return {
    strengths,
    weaknesses,
    courses,
    yAxisScore,
    xAxisScore,
    yAxisPreviousScore,
    xAxisPreviousScore,
    level,
    refetch,
    lowLevelStudents,
    midLevelStudents,
    highLevelStudents,
    loading,
    canSelectTeam,
    error,
    scoreMySkill,
    scoreAllSkill,
    averageScore,
    averageScoreAllTrack,
    certificateImage,
    certificateDownloadUrl,
  };
};

export default useSkillXPResults;
